window.imBreakpoints = {
	sm: 576,
	md: 768,
	lg: 1024,
	xl: 1412
};

// Header.
( function () {
	const header     = document.getElementById( "site-header" );
	const navigation = document.getElementById( "site-header-navigation" );
	const hamburger  = document.getElementById( "site-header-hamburger" );

	// Define sticky header scroll breakpoint.
	let sticky_header_scroll_breakpoint = header.offsetTop;

	if (document.body.classList.contains( "admin-bar" )) {
		if (screen.width > 782) {
			sticky_header_scroll_breakpoint -= 32;
		} else if (screen.width > 600) {
			sticky_header_scroll_breakpoint -= 46;
		}
	}

	/**
	 * Refreshes classes of sticky header.
	 */
	function refresh_sticky_header_classes() {
		if (window.scrollY > sticky_header_scroll_breakpoint) {
			header.classList.add( "-sticky" );
		} else {
			header.classList.remove( "-sticky" );
		}
	}

	window.addEventListener( "scroll", refresh_sticky_header_classes );
	setTimeout( refresh_sticky_header_classes, 50 );

	/**
	 * Toggles header navigation.
	 */
	function on_hamburger_click() {
		if ( navigation.classList.contains( "-active" ) ) {
			header.classList.remove( "-expanded" );
			navigation.classList.remove( "-active" );
			hamburger.classList.remove( "-active" );
		} else {
			header.classList.add( "-expanded" );
			navigation.classList.add( "-active" );
			hamburger.classList.add( "-active" );
		}
	}

	hamburger.addEventListener( "click", on_hamburger_click );

	/**
	 * Toggles submenu by parent item.
	 * @param {HTMLLIElement} $parent
	 */
	function toggle_nav_submenu_by_parent_item( $parent ) {
		const submenu = $parent.querySelector( ":scope > ul.sub-menu" );

		if ( ! submenu ) {
			return;
		}

		if ( submenu.classList.contains( "-active" ) ) {
			hide_nav_submenu_by_parent_item( $parent );
		} else {
			show_nav_submenu_by_parent_item( $parent );
		}
	}

	/**
	 * Shows submenu by parent item.
	 * @param {HTMLLIElement} $parent
	 */
	function show_nav_submenu_by_parent_item( $parent ) {
		const submenu = $parent.querySelector( ":scope > ul.sub-menu" );

		if ( ! submenu ) {
			return;
		}

		submenu.classList.add( "-active" );

		if (window.innerWidth < imBreakpoints.lg) {
			submenu.style.height = submenu.scrollHeight + "px";
		}
	}

	/**
	 * Hides submenu by parent item.
	 * @param {HTMLLIElement} $parent
	 */
	function hide_nav_submenu_by_parent_item( $parent ) {
		const submenu = $parent.querySelector( ":scope > ul.sub-menu" );

		if ( ! submenu ) {
			return;
		}

		submenu.classList.remove( "-active" );

		if (window.innerWidth < imBreakpoints.lg) {
			submenu.style.height = "0";
		}
	}

	// Toggle submenu.
	const menu_parent_items = navigation.querySelectorAll( "li.menu-item-has-children" );
	const menu_parent_links = navigation.querySelectorAll( "li.menu-item-has-children > a" );

	for ( const link of menu_parent_links ) {
		link.addEventListener(
			"click",
			function ( event ) {
				event.preventDefault();
				toggle_nav_submenu_by_parent_item( link.parentElement );
			}
		);

		link.addEventListener(
			"mouseover",
			function () {
				if ( window.innerWidth >= imBreakpoints.lg ) {
					show_nav_submenu_by_parent_item( link.parentElement );
				}
			}
		)
	}

	// Show submenu on menu item hover, hide on unhover (on desktop only).
	for ( const item of menu_parent_items ) {
		item.addEventListener(
			"mouseleave",
			function () {
				if ( window.innerWidth >= imBreakpoints.lg ) {
					hide_nav_submenu_by_parent_item( item );
				}
			}
		)
	}

	// Search show form.
	const site_search_btn = header.querySelector( ".header-search-button" );
	const site_search_bar = header.querySelector( ".search-bar" );

	site_search_btn.addEventListener(
		"click",
		function () {
			if ( site_search_bar.classList.contains( "-active" ) ) {
				site_search_bar.classList.remove( "-active" );
			} else {
				site_search_bar.classList.add( "-active" );
			}
		}
	);
} )();

// Sidebar navigation.
(function () {
	const sidebarNavigationLinks  = document.querySelectorAll( '#side-navigation .navigation-item' );
	let choosenNavigationSections = [];

	for ( const link of sidebarNavigationLinks ) {
		const id             = link.getAttribute( 'href' ).replace( '#', '' );
		const choosenSection = document.getElementById( id );

		if ( choosenSection ) {
			choosenNavigationSections.push( choosenSection );
		}
	}

	function changeLinkState() {
		if ( choosenNavigationSections.length <= 0 ) {
			return;
		}

		let index = choosenNavigationSections.length;

		while (--index && window.scrollY + 250 < choosenNavigationSections[index].offsetTop) {
		}

		sidebarNavigationLinks.forEach( (link) => link.classList.remove( 'active' ) );
		sidebarNavigationLinks[index].classList.add( 'active' );
	}

	changeLinkState();
	window.addEventListener( 'scroll', changeLinkState );
})();

// Dynamic label.
(function () {
	const all_inputs     = document.querySelectorAll( "input" );
	const dynamic_inputs = document.querySelectorAll( ".form-group.-dynamic-label .form-control" );

	/**
	 * @param {HTMLInputElement} input
	 */
	function dynamic_label_refresh( input ) {
		const group = input.closest( ".form-group.-dynamic-label" );

		if ( ! group ) {
			return;
		}

		if ( input === document.activeElement || input.value.trim().length > 0 ) {
			group.classList.add( "-dynamic-label-active" );
		} else {
			group.classList.remove( "-dynamic-label-active" );
		}
	}

	function refresh_dynamic_labels() {
		for ( const input of dynamic_inputs ) {
			dynamic_label_refresh( input );
		}
	}

	// Attach callbacks to events.
	for ( const input of all_inputs ) {
		input.addEventListener( "input", refresh_dynamic_labels );
	}

	for ( const input of dynamic_inputs ) {
		input.addEventListener( "focusin", () => dynamic_label_refresh( input ) );
		input.addEventListener( "focusout", () => dynamic_label_refresh( input ) );
	}

	refresh_dynamic_labels();
})();

// File upload.
(function () {
	const $file_inputs = document.querySelectorAll( ".form-attachment input[type='file']" );

	/**
	 * @param {HTMLInputElement} $input
	 */
	function initialize_file_input( $input ) {
		const $group = $input.closest( ".form-attachment" );
		const $value = ( $group ) ? $group.querySelector( ".attachment-value" ) : null;

		if ( ! $value ) {
			return;
		}

		$value["imDefaultValue"] = $value.innerHTML;
	}

	/**
	 * @param {HTMLInputElement} $input
	 */
	function on_file_input_change( $input ) {
		const $group = $input.closest( ".form-attachment" );
		const $value = ( $group ) ? $group.querySelector( ".attachment-value" ) : null;

		if ( ! $value ) {
			return;
		}

		const selected_file = $input.value.toString().trim();

		if ( selected_file.length > 0 ) {
			$value.innerHTML = selected_file.split( /[\\\/]/ ).pop().trim();
		} else {
			$value.innerHTML = $value["imDefaultValue"];
		}
	}

	for ( const $input of $file_inputs ) {
		initialize_file_input( $input );
		$input.addEventListener( "input", () => on_file_input_change( $input ) );
	}
})();
